import { Controller } from '@hotwired/stimulus';
import { show, hide } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'trixEditor',
    'intentAndDiscussionRelation',
    'characterCounter',
    'submitButton',
  ];

  connect() {
    this.element.addEventListener('trix-focus', this.expandForm.bind(this));
    this.reset();
  }

  collapseForm() {
    this.isCollapsed = true;
    hide(this.intentAndDiscussionRelationTarget);
    hide(this.characterCounterTarget);
    hide(this.submitButtonTarget);
  }

  expandForm() {
    if (this.isCollapsed) {
      this.isCollapsed = false;
      this.element.classList.remove('is-collapsed');
      show(this.intentAndDiscussionRelationTarget);
      show(this.characterCounterTarget);
      show(this.submitButtonTarget);
    }
  }

  reset() {
    this.isCollapsed = true;
    this.element.classList.add('is-collapsed');
    this.enableSubmit();
    this.collapseForm();
  }

  disableSubmit() {
    this.submitButtonTarget.disabled = true;
  }

  enableSubmit() {
    this.submitButtonTarget.disabled = false;
  }
}
